import React from 'react'

import { HeadingXLarge, HeadingLarge, HeadingMedium, BodyText } from '@pb/components'
import { getLabelFromStorage, isArketBrand, isOtherStoriesBrand, isCosBrand } from '@pb/utils'
import cn from 'classnames'

import styles from './Header.scss'
import { Props } from './types'

const Header: React.FC<Props> = ({ status, isDetailPage = false, productsTotal }) => {
  const getHeaderTitle = (): string => {
    if (status === 'submitted') {
      const titles = getLabelFromStorage(
        'profile.unreviewedproducts.review.submitted.reviews.random',
      ).split(',')
      titles.push(getLabelFromStorage('profile.unreviewedproducts.review.submitted.title'))
      const random = Math.floor(Math.random() * titles.length)
      return titles[random]
    }

    return 'profile.unreviewedproducts.review.page.reviews'
  }

  const getHeaderSubTitle = (): string => {
    if ((isCosBrand || isArketBrand) && productsTotal === 0)
      return 'profile.unreviewedproducts.review.page.no.products'
    if (status === 'submitted') {
      return 'profile.unreviewedproducts.review.submitted.reviews.valuable'
    }
    return isCosBrand && isDetailPage
      ? 'profile.unreviewedproducts.review.form.thought'
      : 'profile.unreviewedproducts.review.page.thought'
  }

  return (
    <div className={cn(!isCosBrand ? styles.leaveReviewHeader : undefined)}>
      {isOtherStoriesBrand ? (
        <>
          <HeadingMedium>{getLabelFromStorage(getHeaderTitle())}</HeadingMedium>
          <BodyText meta className={cn(isDetailPage && styles.subTitle)}>
            {getLabelFromStorage(getHeaderSubTitle())}
          </BodyText>
        </>
      ) : isArketBrand ? (
        <>
          <HeadingMedium Tag="h2" className={styles.headingBorder}>
            {getLabelFromStorage(getHeaderSubTitle())}
          </HeadingMedium>
        </>
      ) : isCosBrand ? (
        <>
          <BodyText className={cn(styles.uppercase, styles.header)}>
            {getLabelFromStorage('profile.unreviewedproducts.review.page.reviews')}
          </BodyText>
          {status === 'submitted' && (
            <BodyText meta className={cn(styles.header, styles.subTitleAlt)}>
              {getLabelFromStorage('profile.unreviewedproducts.review.submitted.title')}
            </BodyText>
          )}
          <BodyText meta className={styles.subTitleAlt}>
            {getLabelFromStorage(getHeaderSubTitle())}
          </BodyText>
        </>
      ) : (
        <>
          <HeadingXLarge>{getLabelFromStorage(getHeaderTitle())}</HeadingXLarge>
          <HeadingLarge Tag="h2" className={cn(isDetailPage && styles.subTitle)}>
            {getLabelFromStorage(getHeaderSubTitle())}
          </HeadingLarge>
        </>
      )}
    </div>
  )
}

export default Header
